var map = {
	"./airConditioner.svg": "6463",
	"./breakfast.svg": "f62c",
	"./childFriendly.svg": "4a27",
	"./greatView.svg": "ea62",
	"./miniBar.svg": "1264",
	"./petFriendly.svg": "e086",
	"./phone.svg": "e9f4",
	"./refrigerator.svg": "f3bf",
	"./roomService.svg": "44a7",
	"./smokeFree.svg": "d830",
	"./sofa.svg": "e15b",
	"./television.svg": "9c99",
	"./tick-inside-circle.svg": "d71e",
	"./wifi.svg": "88b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e26e";